import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		// DEV-35101: девять воронок PRD. Тема карточки — по полу (лиловая женская / синяя мужская),
		// кадр — по теме активности; режим add там, где на базе гифтбокс-попапа нет вовсе.
		// Раскладка и обоснования: см. тикет DEV-35101.
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_f_walking_senior_discount_popup~1&age=65
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_f_walking_senior_discount_popup/core-f-replace'),
			},
		},
		'female-water-fasting': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female-water-fasting&exp=web_f_walking_senior_discount_popup~1&age=65
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_f_walking_senior_discount_popup/core-f-replace'),
			},
		},
		'activity-female-tai-chi-walking-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_f_walking_senior_discount_popup~1&age=65
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_f_walking_senior_discount_popup/core-f-replace'),
			},
		},
		'activity-male-tai-chi-yoga-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-pr&exp=web_f_walking_senior_discount_popup~1&age=65
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_f_walking_senior_discount_popup/tai-chi-yoga-m-replace'),
			},
		},
		'activity-male-chair-tai-chi': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi&exp=web_f_walking_senior_discount_popup~1&age=65
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_f_walking_senior_discount_popup/tai-chi-yoga-m-replace'),
			},
		},
		'activity-male-chair-tai-chi-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi-al&exp=web_f_walking_senior_discount_popup~1&age=65
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_f_walking_senior_discount_popup/tai-chi-yoga-m-replace'),
			},
		},
		// male переехал на REPLACE (DEV-35192 раскатал гифтбокс в plan-m); activity-male-tai-chi-yoga
		// остаётся на ADD — его база не менялась.
		male: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=male&exp=web_f_walking_senior_discount_popup~1&age=65
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_f_walking_senior_discount_popup/fasting-m-replace'),
			},
		},
		'activity-male-tai-chi-yoga': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga&exp=web_f_walking_senior_discount_popup~1&age=65
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_f_walking_senior_discount_popup/tai-chi-yoga-m-add'),
			},
		},
	},
]

export default config
